import { render, staticRenderFns } from "./LocalCounselorAI.vue?vue&type=template&id=bd7eb8be&scoped=true"
import script from "./LocalCounselorAI.vue?vue&type=script&lang=js"
export * from "./LocalCounselorAI.vue?vue&type=script&lang=js"
import style0 from "./LocalCounselorAI.vue?vue&type=style&index=0&id=bd7eb8be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7eb8be",
  null
  
)

export default component.exports